<template>
  <div class="body-box marginBox2">
    <el-row class="plan"></el-row>

    <el-form
      ref="editFormRef"
      :model="editForm"
      label-width="140px"
      style="padding: 20px;background-color: #fff;margin-top: 10px;"
    >
      <el-row>
        <!--球场名称-->
        <el-col :span="8">
          <el-form-item label="球场名称(用户)">
            <span class="colorStatus">{{newContent.courtName}}</span>
          </el-form-item>


          <el-form-item label="球场名称">
            <el-input v-model="editForm.title" disabled/>
          </el-form-item>
        </el-col>

        <!--酒店名称-->
        <el-col :span="8">
          <el-form-item label="酒店名称(用户)">
            <span class="colorStatus">{{newContent.hotel}}</span>
          </el-form-item>

          <el-form-item label="酒店名称">
            <el-input v-model="editForm.hotel"/>
          </el-form-item>
        </el-col>

        <!--入住时间-->
        <el-col :span="8">
          <el-form-item label="入住时间(用户)">
            <span class="colorStatus">{{newContent.enterDate | formatDate}}</span>
          </el-form-item>

          <el-form-item label="入住时间">
            <el-date-picker style="width: 100%;" v-model="editForm.enterDate" type="date" value-format="timestamp"></el-date-picker>
          </el-form-item>
        </el-col>

        <!--离店时间-->
        <el-col :span="8">
          <el-form-item label="离店时间(用户)">
            <span class="colorStatus">{{newContent.outDate | formatDate}}</span>
          </el-form-item>

          <el-form-item label="离店时间">
            <el-date-picker style="width: 100%;" v-model="editForm.outDate" type="date" value-format="timestamp"></el-date-picker>
          </el-form-item>
        </el-col>

        <!--接送车需要-->
        <el-col :span="8">
          <el-form-item label="接送车需要(用户)">
            <span class="colorStatus">{{newContent.enumShuttle === 'YES' ? '是' : '否'}}</span>
          </el-form-item>

          <el-form-item label="接送车需要">
            <el-select v-model="editForm.enumShuttle" clearable placeholder="请选择接送车需要" style="width: 100%">
              <el-option key="YES" label="是" value="YES"></el-option>
              <el-option key="NO" label="否" value="NO"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--预约人-->
        <el-col :span="8">
          <el-form-item label="预约人(用户)">
            <span class="colorStatus">{{newContent.userName}}</span>
          </el-form-item>

          <el-form-item label="预约人">
            <el-input v-model="editForm.userName"/>
          </el-form-item>
        </el-col>

        <!--预约人电话-->
        <el-col :span="8">
          <el-form-item label="预约人电话(用户)">
            <span class="colorStatus">{{newContent.tel}}</span>
          </el-form-item>


          <el-form-item label="预约人电话">
            <el-input v-model="editForm.tel"/>
          </el-form-item>
        </el-col>

        <!--预约人邮箱-->
        <el-col :span="8">
          <el-form-item label="预约人邮箱(用户)">
            <span class="colorStatus">{{newContent.email}}</span>
          </el-form-item>

          <el-form-item label="预约人邮箱">
            <el-input v-model="editForm.email"/>
          </el-form-item>
        </el-col>

        <!--送迎车备注-->
        <el-col :span="8">
          <el-form-item label="送迎车备注(用户)">
            <span class="colorStatus">{{newContent.distance}}</span>
          </el-form-item>


          <el-form-item label="送迎车备注">
            <el-input v-model="editForm.distance"/>
          </el-form-item>
        </el-col>

        <!--总金额-->
        <el-col :span="8">
          <el-form-item label="总金额(用户)">
            <span class="colorStatus">{{newContent.cost}}</span>
          </el-form-item>


          <el-form-item label="总金额">
            <el-input v-model="editForm.cost"/>
          </el-form-item>
        </el-col>

        <!--部屋-->
        <el-col :span="8">
          <el-form-item label="部屋(用户)">
            <span class="colorStatus">{{newContent.singleNum}}</span>
          </el-form-item>


          <el-form-item label="部屋">
            <el-input v-model="editForm.singleNum"/>
          </el-form-item>
        </el-col>

        <!--备注-->
        <el-col :span="24">
          <el-form-item label="备注(用户)">
            <span class="colorStatus">{{newContent.brief}}</span>
          </el-form-item>


          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.brief"/>
          </el-form-item>
        </el-col>

        <!--用户修改时间-->
        <el-col :span="24" style="padding: 20px 150px;font-size: 16px">用户上传的时间</el-col>
        <el-col :span="24" v-for="item in newCourtTime">
          <el-row>
            <el-col :span="6">
              <el-form-item label="打球时间">
                <span class="colorStatus">{{item.date}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="打球时间起">
                <span class="colorStatus">{{item.startTime}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="打球时间至">
                <span class="colorStatus">{{item.endTime}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="24" style="padding: 20px 150px;font-size: 16px">
          <span>打球列表</span>
          <el-button @click="replace" style="margin-left: 20px;">替换用户填写的时间</el-button>
        </el-col>
        <el-col :span="24" v-for="item in courtTime">
          <el-row>
            <el-col :span="6">
              <el-form-item label="打球时间">
                <span>{{item.date}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="打球时间起">
                <span>{{item.startTime}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="打球时间至">
                <span>{{item.endTime}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>


        <!--用户修改的-->
        <el-col :span="24" style="padding: 20px 150px;font-size: 16px">用户上传的打球人</el-col>
        <el-col :span="24" v-for="item in newGroupPerson">
          <el-row>
            <el-col :span="6" v-for="u in item.data" :key="u.id">
              <el-form-item label="打球人">
                <span class="colorStatus">{{u.name}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <!--修改打球人-->
        <el-col :span="24" style="padding: 20px 150px;font-size: 16px">
          <span>打球列表</span>
          <el-button @click="replacePeople" style="margin-left: 20px;">替换用户填写的打球人</el-button>
        </el-col>
        <el-col :span="24" v-for="item in groupPerson" :key="item.type">
          <el-row>
            <el-col :span="6" v-for="u in item.data" :key="u.id">
              <el-form-item label="打球人">
                <span>{{u.name}}</span>
              </el-form-item>
            </el-col>

            <!--<el-col :span="4" class="playPerson">
              <span @click="addPlayPerson" class="el-icon-circle-plus-outline"></span>
              <span v-if="index !== 0" @click="subPlayPerson(index)" class="el-icon-remove-outline"></span>
            </el-col>-->
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <div class="goBackBox">
      <el-button @click="submitModifyOrder">修改订单</el-button>
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import { cancelOrdersByOrderId, modifyOrderTravelsById } from '@/api/order/order'

export default {
  name: "modifyTravelOrder",
  data () {
    return {
      editForm: {},
      groupPerson: [],
      orderId: '',
      newContent: {},
      newGroupPerson: [],
      courtTime: [],
      newCourtTime: [],
    }
  },

  created() {
    this.orderId = this.$route.query.orderId
    this.initialize()
  },

  methods: {
    //初始化
    initialize() {
      cancelOrdersByOrderId(this.orderId).then(res => {
        this.editForm = JSON.parse(res.data.rawData)
        this.groupPerson = JSON.parse(this.editForm.groupPerson)
        const list = JSON.parse(this.editForm.courtTime)
        list.forEach(f => {
          f.startTime = f.concreteTime.split(" - ")[0]
          f.endTime = f.concreteTime.split(" - ")[1] ? f.concreteTime.split(" - ")[1] : ''
        })
        this.courtTime = JSON.parse(JSON.stringify(list))
        this.newContent = JSON.parse(res.data.content)
        const list2 = JSON.parse(this.newContent.courtTime)
        list2.forEach(f => {
          f.startTime = f.concreteTime.split(" - ")[0]
          f.endTime = f.concreteTime.split(" - ")[1] ? f.concreteTime.split(" - ")[1] : ''
        })
        this.newCourtTime = JSON.parse(JSON.stringify(list2))
        this.newGroupPerson = JSON.parse(this.newContent.groupPerson)
      })
    },

    //返回
    goBack() {
      this.$router.go(-1)
    },

    replace() {
      this.courtTime = this.newCourtTime
    },

    replacePeople() {
      this.groupPerson = this.newGroupPerson
    },

    submitModifyOrder() {
      let personNum = 0;
      if (this.groupPerson.length > 0) {
        this.groupPerson.forEach((item) => {
          personNum += item.data.length;
        })
      }
      let arr = []
      this.courtTime.forEach((f,i) => {
        const obj = {
          concreteTime: f.endTime ? `${f.startTime} - ${f.endTime}` : f.startTime,
          key: i + 1,
          date: f.date
        }
        arr.push(obj)
      })
      const data = {
        cost: this.editForm.cost,
        courtTime: JSON.stringify(arr),
        email: this.editForm.email,
        enterDate: this.editForm.enterDate,
        enumShuttle: this.editForm.enumShuttle,
        groupPerson: JSON.stringify(this.groupPerson),
        hotel: this.editForm.hotel,
        outDate: this.editForm.outDate,
        personNum: personNum,
        singleNum: this.editForm.singleNum,
        tel: this.editForm.tel,
        userName: this.editForm.userName,
        brief: this.editForm.brief,
        distance: this.editForm.distance
      }

      modifyOrderTravelsById(data, this.orderId).then(res => {
        if (res.code === '0') {
          this.$message.success('执行成功!')
          this.goBack()
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.colorStatus {
  color: red;
}
</style>
